// extracted by mini-css-extract-plugin
module.exports = {"communityContainer":"Community_communityContainer__L1ANB","icons":"Community_icons__aI35I","iconContainer":"Community_iconContainer__ZlewZ","text":"Community_text__N7jbx"};